/**
 * Feature flags — single source of truth for UI features that need to be
 * hidden or revealed without ripping code out. Flip the boolean here and
 * every surface in the app that gates on it follows.
 *
 * FEATURE_ESCALATIONS — when false, the Escalate button on every stage
 * panel, the /escalations queue page, the sidebar "My Escalations" link,
 * the dashboard KPI card, the Pipeline Activity tab's "My open
 * escalations" section, and Settings → Escalation Routing are all
 * hidden. Existing escalation comments in the per-job activity feed
 * (JobCommentsPanel) are still shown — they're historical context.
 *
 * FALLBACK / KILL SWITCH: flip FEATURE_ESCALATIONS to `true` to bring
 * every escalation surface back. No other file needs to change. The
 * backend endpoints (POST /jobs/{id}/stages/{stage}/escalate, GET
 * /escalations, PATCH /escalations/{id}) are unchanged regardless of
 * the flag — only the UI is gated. Full list of gated surfaces and the
 * reasoning behind hiding them lives in docs/session-2026-05-22.md
 * (see "Escalation hide for demo" + "What's NOT hidden").
 */

// Type annotated as plain `boolean` so consumers don't get narrowed to a
// literal false at compile time — every conditional that reads this
// stays valid both ways without ESLint flagging "always falsy".
//
// 2026-07-14: re-enabled. Reviewers need "send back with notes to whoever is
// applicable" at the gates; the backend escalation routing was always live.
export const FEATURE_ESCALATIONS: boolean = true;
